import React from 'react';

const JS_Comparison = () => {
  return (
    <div >
      <h1>JS_Comparison</h1>
      <p>Placeholder component for: "JS Comparison"</p>
    </div>
  );
};

export default JS_Comparison;
